<div class="data-table-column" *ngIf="template" [ngClass]="{ 'align-right': alignRight, 'align-center': alignCenter }">
    <ng-template [ngTemplateOutlet]="template"
                 [ngTemplateOutletContext]="context"></ng-template>
</div>

